import React from 'react';
import App from '../src copy/App';

function Map() {
    return (

        <div>
            <App />
        </div>
    );
}
export default Map;